import { OptimizelyFeatureFlags } from 'constants/optimizely'
import { getOptimizelyFeatureFlagVariation } from 'lib/optimizely/optimizelyUtils'

export const isMaldivesCharterCarouselEnabled = (state: App.State) => getOptimizelyFeatureFlagVariation(state, OptimizelyFeatureFlags.croMaldiveNavTab)
